var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEstabelecimentoReligiosoIcone = function SvgEstabelecimentoReligiosoIcone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.751 0.366682C7.81295 0.281548 8 0 8 0C8 0 8.22671 0.335205 8.249 0.366682C8.30035 0.438459 8.35288 0.512407 8.40697 0.588556C8.51976 0.747363 8.63976 0.916317 8.76971 1.09452C9.66414 2.31693 11 4.15163 11 5.20588C11 5.97554 10.6606 6.67191 10.1171 7.17769C9.53956 7.71029 8.78346 8.00394 8 7.99996C7.21866 8.00267 6.46416 7.71332 5.88286 7.18804C5.33943 6.68226 5 5.98632 5 5.21666C5 4.16241 6.33586 2.31737 7.23029 1.09452C7.43386 0.820289 7.60357 0.588311 7.751 0.366682Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 18.4477 0.447715 18 1 18H5V11C5 9.89543 5.89543 9 7 9H9C10.1046 9 11 9.89543 11 11V18H15C15.5523 18 16 18.4477 16 19V20H0V19Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstabelecimentoReligiosoIcone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estabelecimento-religioso-icone.38659739.svg";
export { ForwardRef as ReactComponent };